import React, {Component} from 'react';
import { observable, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";
import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import ReviewsOverview from "../../../components/common/ReviewsOverview";
import ReviewsSentiment from "../../../components/common/ReviewsSentiment";


import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
  Button,
  Col, Row
} from "shards-react";
import moment from "moment";


@inject(({ common }) => ({ getDashBoardReport: common.getDashBoardReport }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ review }) => ({ getSurveyAnswerStatsSummary: review.getSurveyAnswerStatsSummary }))

@observer
class Dashboard extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //page
  @observable firstDataDay;
  @observable dashBoardReport;
  @observable reDashBoardData = {
    orderCount: [],
    cancelCount: [],
    reviewCount: [],
    currentMonthReviewCount: [],
    currentMonthReviewDays: [],
    pastMonthReviewCount: [],
    pastMonthReviewDays: [],
  };
  @observable smallStats = [];

  // 설문 답변 통계
  @observable surveyStats = null;

  // (로그인 안내 팝업은 DefaultLayout 의 LoginNoticeModal 로 이전됨)


  //list
  @observable searchParams = {
    keyword: ''
  };
  @observable list = [];

  constructor(props) {
    super(props);
    this.init()
  }


  @action
  init = async (key) => {
    if(this.props.isLogin) {
      this.isLoading = true;
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.permissions = this.props.me.permissions;

      this.searchParams = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo
      }

      this.getDashBaordData()
      this.getSurveyStats()
      this.isLoading = false;

    }
  };

  @action
  getDashBaordData = async () => {
    this.dashBoardReport = await this.props.getDashBoardReport(this.searchParams);
    this.firstDataDay = moment().subtract(7, 'days');
    this.lastWeekDay = moment().subtract(14, 'days');
    this.pastMonthFirstDay = moment().subtract(this.dashBoardReport.reviewDaysCount, 'days');
    this.dashBoardReport.days = [];

    this.refactoringData();
  }

  @action
  getSurveyStats = async () => {
    let _this = this;
    this.props.getSurveyAnswerStatsSummary({
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo
    }, function(res) {
      if (res && res.data && Array.isArray(res.data)) {
        // { data: [...] } 형태
        _this.surveyStats = {
          items: res.data,
          totalResponses: res.data.reduce(function(sum, item) {
            return sum + (item.totalCount || 0);
          }, 0)
        };
      }
    });
  }

  @action
  refactoringData = (data) => {

    for(let i in this.dashBoardReport.report) {
      this.dashBoardReport.report[i].day = moment(this.dashBoardReport.report[i].day).format('YYYY-MM-DD');
    }
    let reviewCountsByDay = _.indexBy(this.dashBoardReport.review, '_id');
    // console.log(reviewCountsByDay, this.dashBoardReport.reviewDaysCount)


    this.reDashBoardData.orderCountSum = this.dashBoardReport.thisWeekSalesCount.orderCount;
    this.reDashBoardData.pastWeekOrderCountSum = this.dashBoardReport.lastWeekSalesCount.orderCount;
    this.reDashBoardData.cancelCountSum = 0;
    this.reDashBoardData.reviewCountSum = 0;
    this.reDashBoardData.pastWeekCountSum = 0;
    let cDayIndex = 0;
    for(let i = 0; i < 14; i++) {
      let currentDate = moment(this.lastWeekDay).add(i, 'days').format('YYYY-MM-DD');

      if(i > 7) {
        cDayIndex = i - 8;
        // if(reportCountsByDay[currentDate]) {
        //   this.reDashBoardData.orderCount[cDayIndex] = reportCountsByDay[currentDate].orderCount;
        //   this.reDashBoardData.orderCountSum += reportCountsByDay[currentDate].orderCount;
        //   this.reDashBoardData.cancelCount[cDayIndex] = reportCountsByDay[currentDate].cancelCount
        //   this.reDashBoardData.cancelCountSum += reportCountsByDay[currentDate].cancelCount;
        // }
        // else {
        //   this.reDashBoardData.orderCount[cDayIndex] = 0;
        //   this.reDashBoardData.cancelCount[cDayIndex] = 0;
        // }

        if(reviewCountsByDay[currentDate]) {
          this.reDashBoardData.reviewCount[cDayIndex] = reviewCountsByDay[currentDate].count
          this.reDashBoardData.reviewCountSum += reviewCountsByDay[currentDate].count;
        }
        else {
          this.reDashBoardData.reviewCount[cDayIndex] = 0;
        }
        this.dashBoardReport.days.push(currentDate)
      }
      else {
        if(reviewCountsByDay[currentDate]) {
          this.reDashBoardData.pastWeekCountSum += reviewCountsByDay[currentDate].count;
        }
      }
      //this.dashBoardReport.days.push(currentDate)
    }


    let currentMonth = moment().format('YYYY-MM');
    let cIndex = 0;
    let pIndex = 0;
    for(let i = 0; i < this.dashBoardReport.reviewDaysCount+1; i++) {
      let currentDate = moment(this.pastMonthFirstDay).add(i, 'days');
      let formattedDate = currentDate.format('YYYY-MM-DD');
      let monthOfCurrentDate = currentDate.format('YYYY-MM');

      if(monthOfCurrentDate === currentMonth) {
        // 이번달 리뷰수
        if(reviewCountsByDay[formattedDate]) {
          this.reDashBoardData.currentMonthReviewCount[cIndex] = reviewCountsByDay[formattedDate].count;
          this.reDashBoardData.currentMonthReviewCountSum += reviewCountsByDay[formattedDate].count;
        }
        else {
          this.reDashBoardData.currentMonthReviewCount[cIndex] = 0;
        }
        this.reDashBoardData.currentMonthReviewDays.push(formattedDate);
        cIndex++;
      } else {
        // 지난달 리뷰수
        if(reviewCountsByDay[formattedDate]) {
          this.reDashBoardData.pastMonthReviewCount[pIndex] = reviewCountsByDay[formattedDate].count;
          this.reDashBoardData.pastMonthReviewCountSum += reviewCountsByDay[formattedDate].count;
        }
        else {
          this.reDashBoardData.pastMonthReviewCount[pIndex] = 0;
        }
        this.reDashBoardData.pastMonthReviewDays.push(formattedDate);
        pIndex++;
      }
    }

    // console.log(this.reDashBoardData.currentMonthReviewCount)
    // console.log(this.reDashBoardData.currentMonthReviewDays)
    // console.log(this.reDashBoardData.pastMonthReviewCount)

    this.applyGraphData();
  }

  @action
  applyGraphData = () => {

    let incPer = "-";
    let increase = this.reDashBoardData.reviewCountSum - this.reDashBoardData.pastWeekCountSum >= 0;
    let decrease = this.reDashBoardData.reviewCountSum - this.reDashBoardData.pastWeekCountSum < 0;
    if(this.reDashBoardData.reviewCountSum > 0 && this.reDashBoardData.pastWeekCountSum > 0) {
      if(increase) {
        incPer = this.reDashBoardData.reviewCountSum - this.reDashBoardData.pastWeekCountSum === 0 ? 0 : (this.reDashBoardData.reviewCountSum - this.reDashBoardData.pastWeekCountSum) / this.reDashBoardData.pastWeekCountSum * 100;
      } else {
        incPer = this.reDashBoardData.pastWeekCountSum - this.reDashBoardData.reviewCountSum === 0 ? 0 : (this.reDashBoardData.pastWeekCountSum - this.reDashBoardData.reviewCountSum) / this.reDashBoardData.pastWeekCountSum * 100;
      }
      incPer = parseInt(incPer);
    }
    console.log(this.reDashBoardData.reviewCountSum, this.reDashBoardData.pastWeekCountSum)

    let oincPer = "-";
    let oincrease = this.reDashBoardData.orderCountSum - this.reDashBoardData.pastWeekOrderCountSum >= 0;
    let odecrease = this.reDashBoardData.orderCountSum - this.reDashBoardData.pastWeekOrderCountSum < 0;
    if(this.reDashBoardData.orderCountSum > 0 && this.reDashBoardData.pastWeekOrderCountSum > 0) {
      if(oincrease) {
        oincPer = this.reDashBoardData.orderCountSum - this.reDashBoardData.pastWeekOrderCountSum === 0 ? 0 : (this.reDashBoardData.orderCountSum - this.reDashBoardData.pastWeekOrderCountSum) / this.reDashBoardData.pastWeekOrderCountSum * 100;
      } else {
        oincPer = this.reDashBoardData.pastWeekOrderCountSum - this.reDashBoardData.orderCountSum === 0 ? 0 : (this.reDashBoardData.pastWeekOrderCountSum - this.reDashBoardData.orderCountSum) / this.reDashBoardData.pastWeekOrderCountSum * 100;
      }
      oincPer = parseInt(oincPer);
    }

    this.smallStats = [
      {
        label: "최근 7일 리뷰수",
        value: this.reDashBoardData.reviewCountSum,
        percentage: incPer + "%",
        increase: increase,
        decrease: decrease,
        chartLabels: [null, null, null, null, null, null, null],
        attrs: { md: "6", sm: "6" },
        datasets: [
          {
            label: "Today",
            fill: "start",
            borderWidth: 1.5,
            backgroundColor: "rgba(0, 184, 216, 0.1)",
            borderColor: "rgb(0, 184, 216)",
            data: this.reDashBoardData.reviewCount
          }
        ]
      },
      {
        label: "최근 7일 판매건수",
        value: this.reDashBoardData.orderCountSum,
        percentage: oincPer + "%",
        increase: oincrease,
        decrease: odecrease,
        chartLabels: [this.reDashBoardData.pastWeekOrderCountSum, this.reDashBoardData.orderCountSum],
        attrs: { md: "6", sm: "6" },
        datasets: [
          {
            label: "Week",
            fill: "start",
            borderWidth: 1.5,
            backgroundColor: "rgba(23,198,113,0.1)",
            borderColor: "rgb(23,198,113)",
            data: [this.reDashBoardData.pastWeekOrderCountSum]
          }
        ]
      }
    ];


    // this.smallStats = [
    //   {
    //     label: "최근 7일 리뷰수",
    //     value: "239",
    //     percentage: "10.7%",
    //     increase: true,
    //     chartLabels: [null, null, null, null, null, null, null],
    //     attrs: { md: "6", sm: "6" },
    //     datasets: [
    //       {
    //         label: "Today",
    //         fill: "start",
    //         borderWidth: 1.5,
    //         backgroundColor: "rgba(0, 184, 216, 0.1)",
    //         borderColor: "rgb(0, 184, 216)",
    //         data: [280,
    //           320,
    //           320,
    //           340,
    //           291,
    //           310,
    //           425
    //         ]
    //       }
    //     ]
    //   },
    //   {
    //     label: "최근 7일 판매건수",
    //     value: "182",
    //     percentage: "12.4",
    //     increase: true,
    //     chartLabels: [null, null, null, null, null, null, null],
    //     attrs: { md: "6", sm: "6" },
    //     datasets: [
    //       {
    //         label: "Today",
    //         fill: "start",
    //         borderWidth: 1.5,
    //         backgroundColor: "rgba(23,198,113,0.1)",
    //         borderColor: "rgb(23,198,113)",
    //         data: [280,
    //           220,
    //           320,
    //           340,
    //           491,
    //           410,
    //           525
    //         ]
    //       }
    //     ]
    //   }
    // ]

  }


  render() {

    this.smallStatsData = toJS(this.smallStats);

    // Calculate setup completion status
    // 리뷰 수가 1개 이상이면 설정 완료로 간주
    const setupComplete = this.dashBoardReport && this.dashBoardReport.totlaReviewCount > 0;

    return (
      <div className="main-content dashboard-page">
        <PageTitle />

        {/* Premium Dashboard Header */}
        <div className="dashboard-hero" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '16px',
          padding: '30px',
          marginBottom: '30px',
          boxShadow: '0 10px 40px rgba(102, 126, 234, 0.2)',
          color: 'white'
        }}>
          <Row>
            <Col md="6">
              <h2 className="dashboard-hero__title" style={{margin: '0 0 10px 0', fontSize: '28px', fontWeight: '700', color: '#ffffff'}}>
                안녕하세요, {this.teamUser.name || this.store.storeName}님 👋
              </h2>
              <p style={{margin: 0, fontSize: '16px', opacity: 0.9, color: '#ffffff'}}>
                {moment().format('YYYY년 MM월 DD일')} · 온리플 리뷰 관리 대시보드
              </p>
            </Col>
            <Col md="6" className="dashboard-hero__info" style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '15px'}}>
              {/* 샵 정보 */}
              <div style={{
                textAlign: 'center',
                padding: '12px 20px',
                background: 'rgba(255,255,255,0.15)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
                minWidth: '140px'
              }}>
                <div style={{fontSize: '13px', opacity: 0.85, marginBottom: '5px'}}>
                  <FeatherIcon icon="shopping-bag" size="14" style={{marginRight: '5px', verticalAlign: 'middle'}}/>
                  선택된 샵
                </div>
                <div style={{fontSize: '16px', fontWeight: '600'}}>
                  {this.teamUser.shop ? this.teamUser.shop.shopName : `Shop #${this.teamUser.selShopNo || 1}`}
                </div>
              </div>

              {/* 결제 상태 */}
              <div style={{
                textAlign: 'center',
                padding: '12px 20px',
                background: this.teamUser.isPaidShop ? 'rgba(72, 187, 120, 0.3)' : 'rgba(245, 101, 101, 0.3)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
                minWidth: '140px'
              }}>
                <div style={{fontSize: '13px', opacity: 0.85, marginBottom: '5px'}}>
                  <FeatherIcon icon="credit-card" size="14" style={{marginRight: '5px', verticalAlign: 'middle'}}/>
                  결제 상태
                </div>
                <div style={{fontSize: '16px', fontWeight: '600'}}>
                  {this.teamUser.isPaidShop ? (
                    <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'}}>
                      <span style={{width: '8px', height: '8px', borderRadius: '50%', background: '#48bb78', display: 'inline-block'}}></span>
                      이용 중
                    </span>
                  ) : (
                    <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'}}>
                      <span style={{width: '8px', height: '8px', borderRadius: '50%', background: '#f56565', display: 'inline-block'}}></span>
                      미결제
                    </span>
                  )}
                </div>
                {this.teamUser.selShopExpiryDate && (
                  <div style={{fontSize: '11px', opacity: 0.8, marginTop: '3px'}}>
                    {moment(this.teamUser.selShopExpiryDate) < moment() ? (
                      <span style={{color: '#feb2b2'}}>만료됨</span>
                    ) : (
                      <span>~{moment(this.teamUser.selShopExpiryDate).format('YY.MM.DD')}</span>
                    )}
                  </div>
                )}
              </div>

              {/* 총 리뷰 수 */}
              <div style={{
                textAlign: 'center',
                padding: '12px 20px',
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
                minWidth: '100px'
              }}>
                <div style={{fontSize: '28px', fontWeight: '700', marginBottom: '3px'}}>
                  {(this.dashBoardReport && this.dashBoardReport.totlaReviewCount) || 0}
                </div>
                <div style={{fontSize: '12px', opacity: 0.9}}>총 리뷰 수</div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Setup Status Card - Show if not complete */}
        {!setupComplete && (
          <div style={{
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            borderRadius: '16px',
            padding: '25px',
            marginBottom: '30px',
            color: 'white',
            boxShadow: '0 8px 30px rgba(240, 147, 251, 0.3)'
          }}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
              <FeatherIcon icon="alert-circle" size="24" style={{marginRight: '12px'}}/>
              <h4 style={{margin: 0, fontSize: '18px', fontWeight: '600'}}>
                초기 설정을 완료해 주세요
              </h4>
            </div>
            <p style={{margin: '0 0 15px 0', fontSize: '14px', opacity: 0.9}}>
              온리플 서비스를 사용하려면 초기 설정을 완료해야 합니다. 상품 동기화, 리뷰 가져오기, 스킨 활성화를 진행해주세요.
            </p>
            <Button
              onClick={() => window.location.href = '/easySetting'}
              style={{
                background: 'white',
                color: '#f5576c',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '14px'
              }}
            >
              <FeatherIcon icon="settings" size="16" style={{marginRight: '8px'}}/>
              설정 페이지로 이동
            </Button>
          </div>
        )}

        {/* Key Metrics Grid */}
        {(() => {
          const unreplied = (this.dashBoardReport && this.dashBoardReport.unrepliedReviewCount) || 0;
          // 리뷰 전환율 - 이번달 기준 (API 데이터 → 주간 데이터 폴백)
          const apiMonthReviews = (this.dashBoardReport && this.dashBoardReport.thisMonthReviewCount) || 0;
          const apiMonthOrders = (this.dashBoardReport && this.dashBoardReport.totalOrderCount) || 0;
          const weeklyReviews = (this.reDashBoardData.reviewCountSum || 0) + (this.reDashBoardData.pastWeekCountSum || 0);
          const weeklyOrders = (this.reDashBoardData.orderCountSum || 0) + (this.reDashBoardData.pastWeekOrderCountSum || 0);
          // API 월간 데이터가 있으면 사용, 없으면 최근 2주 데이터 사용
          const effectiveReviews = apiMonthReviews > 0 ? apiMonthReviews : weeklyReviews;
          const effectiveOrders = apiMonthOrders > 0 ? apiMonthOrders : weeklyOrders;
          const reviewRate = effectiveOrders > 0
            ? Math.min(Math.round((effectiveReviews / effectiveOrders) * 100), 100) : 0;
          const lastMonthReviews = (this.dashBoardReport && this.dashBoardReport.lastMonthReviewCount) || 0;
          const lastMonthOrders = (this.dashBoardReport && this.dashBoardReport.lastMonthOrderCount) || 0;
          const lastReviewRate = lastMonthOrders > 0
            ? Math.min(Math.round((lastMonthReviews / lastMonthOrders) * 100), 100)
            : (this.reDashBoardData.pastWeekOrderCountSum > 0
              ? Math.min(Math.round((this.reDashBoardData.pastWeekCountSum / this.reDashBoardData.pastWeekOrderCountSum) * 100), 100) : 0);
          // 리뷰 전환율 점수 (20% = 100점 기준, 20% 초과 시 100점)
          const reviewScore = Math.min(Math.round((reviewRate / 20) * 100), 100);
          const lastReviewScore = Math.min(Math.round((lastReviewRate / 20) * 100), 100);
          const reviewScoreDiff = reviewScore - lastReviewScore;
          const reviewScoreLabel = reviewScore >= 80 ? '우수' : reviewScore >= 60 ? '좋음' : reviewScore >= 40 ? '보통' : reviewScore >= 20 ? '노력 필요' : '시작 단계';
          const reviewScoreColor = reviewScore >= 80 ? '#38a169' : reviewScore >= 60 ? '#3182ce' : reviewScore >= 40 ? '#d69e2e' : '#e53e3e';
          const orderGrowth = this.reDashBoardData.pastWeekOrderCountSum > 0
            ? Math.round(((this.reDashBoardData.orderCountSum - this.reDashBoardData.pastWeekOrderCountSum) / this.reDashBoardData.pastWeekOrderCountSum) * 100) : 0;
          const avgRating = this.dashBoardReport && this.dashBoardReport.avgRating > 0
            ? (this.dashBoardReport.avgRating / 20).toFixed(1)
            : (this.dashBoardReport && this.dashBoardReport.totlaReviewCount > 0
              ? ((this.dashBoardReport.over60Count / this.dashBoardReport.totlaReviewCount) * 5).toFixed(1) : '-');
          const ratingLabel = avgRating >= 4.5 ? '매우 좋음' : avgRating >= 4.0 ? '좋음' : avgRating >= 3.0 ? '보통' : '개선 필요';
          const ratingColor = avgRating >= 4.5 ? '#38a169' : avgRating >= 4.0 ? '#3182ce' : avgRating >= 3.0 ? '#d69e2e' : '#e53e3e';
          const unrepliedColor = unreplied === 0 ? '#38a169' : unreplied <= 5 ? '#d69e2e' : '#e53e3e';
          const unrepliedLabel = unreplied === 0 ? '모두 답글 완료!' : unreplied <= 5 ? '곧 완료할 수 있어요' : '답글이 필요해요';

          const MetricCard = ({icon, iconBg, title, period, value, valueColor, sub, subColor, action, actionTo}) => (
            <Col lg="3" md="6" sm="12" className="mb-4">
              <div style={{
                background: 'white', borderRadius: '12px', padding: '20px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.08)', height: '100%',
                border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column'
              }}>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px'}}>
                  <div style={{
                    width: '40px', height: '40px', borderRadius: '10px',
                    background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    <FeatherIcon icon={icon} size="20" style={{color: 'white'}}/>
                  </div>
                  <div>
                    <div style={{fontSize: '13px', color: '#718096', fontWeight: '600'}}>{title}</div>
                    {period && <div style={{fontSize: '10px', color: '#a0aec0'}}>{period}</div>}
                  </div>
                </div>
                <div style={{fontSize: '30px', fontWeight: '800', color: valueColor || '#1a202c', lineHeight: 1, marginBottom: '8px'}}>
                  {value}
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap'}}>
                  {subColor ? (
                    <span style={{fontSize: '12px', fontWeight: '700', color: subColor, background: subColor + '15', borderRadius: '4px', padding: '2px 6px'}}>{sub}</span>
                  ) : (
                    <span style={{fontSize: '12px', color: '#718096'}}>{sub}</span>
                  )}
                </div>
                {action && (
                  <a href={actionTo} style={{
                    marginTop: 'auto', paddingTop: '12px', fontSize: '12px',
                    color: '#5664D2', fontWeight: '600', textDecoration: 'none',
                    display: 'flex', alignItems: 'center', gap: '4px'
                  }}>
                    {action} <FeatherIcon icon="arrow-right" size="12"/>
                  </a>
                )}
              </div>
            </Col>
          );

          return (
            <Row style={{marginBottom: '30px'}}>
              <MetricCard
                icon="message-circle" iconBg="#e53e3e"
                title="미답글 리뷰"
                period="최근 30일"
                value={unreplied + '건'}
                valueColor={unrepliedColor}
                sub={unrepliedLabel}
                subColor={unrepliedColor}
                action="리뷰 답글 달기" actionTo="/reviewList"
              />
              <MetricCard
                icon="repeat" iconBg="linear-gradient(135deg, #667eea, #764ba2)"
                title="리뷰 전환 점수"
                period={(apiMonthOrders > 0 ? '이번달' : '최근 2주') + ' · 전환율 ' + reviewRate + '%'}
                value={reviewScore + '점'}
                valueColor={reviewScoreColor}
                sub={reviewScoreLabel + (reviewScoreDiff !== 0 ? (' · ' + (reviewScoreDiff >= 0 ? '↑' : '↓') + Math.abs(reviewScoreDiff) + '점 ' + (apiMonthOrders > 0 ? '지난달' : '지난주') + ' 대비') : '')}
                subColor={reviewScoreColor}
              />
              <MetricCard
                icon="shopping-bag" iconBg="linear-gradient(135deg, #38a169, #68d391)"
                title="주간 매출"
                period="최근 7일"
                value={(this.reDashBoardData.orderCountSum || 0).toLocaleString() + '건'}
                sub={orderGrowth >= 0 ? '↑ ' + orderGrowth + '% 지난주 대비' : '↓ ' + Math.abs(orderGrowth) + '% 지난주 대비'}
                subColor={orderGrowth >= 0 ? '#38a169' : '#e53e3e'}
              />
              <MetricCard
                icon="star" iconBg="linear-gradient(135deg, #d69e2e, #ecc94b)"
                title="고객 만족도"
                period="전체 기간"
                value={avgRating + '점'}
                valueColor={ratingColor}
                sub={ratingLabel}
                subColor={ratingColor}
              />
            </Row>
          );
        })()}

        {/* Charts Section */}
        <Row>
          {/* Monthly Review Trend */}
          <Col lg="8" md="12" sm="12" className="mb-4">
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '24px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
            }}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <div>
                  <h5 style={{margin: '0 0 5px 0', fontSize: '18px', fontWeight: '600', color: '#2d3748'}}>
                    월별 리뷰 트렌드
                  </h5>
                  <p style={{margin: 0, fontSize: '13px', color: '#718096'}}>
                    이번 달과 지난 달 리뷰 작성 추이
                  </p>
                </div>
                <div style={{
                  display: 'flex',
                  gap: '15px',
                  fontSize: '13px'
                }}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                    <div style={{width: '12px', height: '12px', borderRadius: '3px', background: '#4facfe'}}></div>
                    <span style={{color: '#718096'}}>이번 달</span>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                    <div style={{width: '12px', height: '12px', borderRadius: '3px', background: '#cbd5e0'}}></div>
                    <span style={{color: '#718096'}}>지난 달</span>
                  </div>
                </div>
              </div>
              {this.reDashBoardData.currentMonthReviewCount.length > 0 ?
                <ReviewsOverview reDashBoardData={this.reDashBoardData}/> :
                <div style={{textAlign: 'center', padding: '40px', color: '#718096'}}>
                  <FeatherIcon icon="bar-chart-2" size="48" style={{opacity: 0.3, marginBottom: '10px'}}/>
                  <p>데이터를 불러오는 중입니다...</p>
                </div>
              }
            </div>
          </Col>

          {/* Review Impact */}
          <Col lg="4" md="12" sm="12" className="mb-4">
            {this.dashBoardReport ?
                <ReviewsSentiment
                    totalReviews={this.dashBoardReport.totlaReviewCount || 0}
                    thisWeekReviews={this.reDashBoardData.reviewCountSum || 0}
                    lastWeekReviews={this.reDashBoardData.pastWeekCountSum || 0}
                    thisWeekOrders={this.reDashBoardData.orderCountSum || 0}
                    lastWeekOrders={this.reDashBoardData.pastWeekOrderCountSum || 0}
                    positiveRate={this.dashBoardReport.totlaReviewCount > 0
                      ? Math.round((this.dashBoardReport.over60Count / this.dashBoardReport.totlaReviewCount) * 100)
                      : 0}
                    reviewWriteRate={this.dashBoardReport.reviewWriteRate || 0}
                    totalOrderCount={this.dashBoardReport.totalOrderCount || 0}
                    reviewedOrderCount={this.dashBoardReport.reviewedOrderCount || 0}
                    thisMonthOrderCount={this.dashBoardReport.thisMonthOrderCount || 0}
                    lastMonthOrderCount={this.dashBoardReport.lastMonthOrderCount || 0}
                    thisMonthReviewCount={this.dashBoardReport.thisMonthReviewCount || 0}
                    lastMonthReviewCount={this.dashBoardReport.lastMonthReviewCount || 0}
                    replyStats={this.dashBoardReport.replyStats || { total: 0, writeCount: 0, aiWriteCount: 0 }}
                    avgRating={this.dashBoardReport.avgRating || 0}
                /> :
                <div style={{textAlign: 'center', padding: '40px', color: '#718096'}}>
                  <FeatherIcon icon="trending-up" size="48" style={{opacity: 0.3, marginBottom: '10px'}}/>
                  <p>데이터를 불러오는 중입니다...</p>
                </div>
            }
          </Col>
        </Row>

        {/* Survey Stats Section */}
        <Row>
          <Col lg="12" md="12" sm="12" className="mb-4">
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '24px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
            }}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <div>
                  <h5 style={{margin: '0 0 5px 0', fontSize: '18px', fontWeight: '600', color: '#2d3748'}}>
                    <FeatherIcon icon="clipboard" size="20" style={{marginRight: '8px', verticalAlign: 'middle'}}/>
                    설문 응답 통계
                  </h5>
                  <p style={{margin: 0, fontSize: '13px', color: '#718096'}}>
                    고객 설문 응답 현황 {this.surveyStats && this.surveyStats.totalResponses ? '(총 ' + this.surveyStats.totalResponses + '건)' : ''}
                  </p>
                </div>
                <div style={{display: 'flex', gap: '8px'}}>
                  <Button
                    size="sm"
                    theme="primary"
                    onClick={() => window.location.href = '/surveyStats'}
                    style={{fontSize: '13px'}}
                  >
                    <FeatherIcon icon="bar-chart-2" size="14" style={{marginRight: '5px'}}/>
                    설문 통계
                  </Button>
                  <Button
                    size="sm"
                    theme="light"
                    onClick={() => window.location.href = '/surveyReviewConfig'}
                    style={{fontSize: '13px'}}
                  >
                    설문 관리 <FeatherIcon icon="arrow-right" size="14" style={{marginLeft: '5px'}}/>
                  </Button>
                </div>
              </div>

              {this.surveyStats && this.surveyStats.items && this.surveyStats.items.length > 0 ? (
              <Row>
                {this.surveyStats.items.slice(0, 4).map((item, idx) => (
                  <Col lg="3" md="6" sm="12" key={idx} className="mb-3">
                    <div style={{
                      background: '#f8fafc',
                      borderRadius: '10px',
                      padding: '20px',
                      height: '100%'
                    }}>
                      <div style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#4a5568',
                        marginBottom: '15px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                        {item.surveyItemName}
                      </div>

                      {/* 답변 분포 */}
                      {item.answers && item.answers.slice(0, 5).map((answer, aIdx) => {
                        var percentage = item.totalCount > 0 ? Math.round((answer.count / item.totalCount) * 100) : 0;
                        return (
                          <div key={aIdx} style={{marginBottom: '10px'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                              <span style={{fontSize: '12px', color: '#718096', maxWidth: '70%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {answer.answerValue}
                              </span>
                              <span style={{fontSize: '12px', fontWeight: '600', color: '#4a5568'}}>
                                {percentage}%
                              </span>
                            </div>
                            <div style={{
                              width: '100%',
                              height: '6px',
                              background: '#e2e8f0',
                              borderRadius: '3px',
                              overflow: 'hidden'
                            }}>
                              <div style={{
                                width: percentage + '%',
                                height: '100%',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderRadius: '3px',
                                transition: 'width 0.3s ease'
                              }}></div>
                            </div>
                          </div>
                        );
                      })}

                      <div style={{
                        fontSize: '11px',
                        color: '#a0aec0',
                        marginTop: '10px',
                        textAlign: 'right'
                      }}>
                        응답 {item.totalCount || 0}건
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
              ) : (
              <div style={{
                textAlign: 'center',
                padding: '50px 20px',
                color: '#718096'
              }}>
                <FeatherIcon icon="clipboard" size="48" style={{opacity: 0.3, marginBottom: '15px'}}/>
                <p style={{margin: '0 0 10px 0', fontSize: '15px', fontWeight: '500'}}>
                  설문 응답 데이터가 없습니다
                </p>
                <p style={{margin: 0, fontSize: '13px', color: '#a0aec0'}}>
                  설문을 설정하고 고객 응답을 수집해보세요
                </p>
              </div>
              )}
            </div>
          </Col>
        </Row>

        {/* 로그인 안내 팝업은 DefaultLayout 의 LoginNoticeModal 로 이전됨 */}
      </div>
    )
  }
}

export default Dashboard;
